import { Constants } from "./constants";

export class InboxBids {
    public owner: String = Constants.USER;
    public type: String = "inboxBids";
    public _id: String = "";
}


// WEBPACK FOOTER //
// ./src/app/shared/models/inboxBids.ts